import { Button } from "@mantine/core";
import React, { useRef } from "react";
import { useFormRender } from "../hooks/useFormRender";
import { getEditOrderFormSchema } from "../pages/operation/order";
import { useTranslation } from "react-i18next";
import { pickCommissionAffectingSnapshot } from "../helpers/commissionOrderChangeUtils";
import { applyCommissionRegenerationPrompt } from "../helpers/prepareOrderSaveWithCommissionPrompt";
import { getProductId } from "../helpers/orderProductUtils";

const OrderEditButton = ({ mainForm, label = "Edit Order" }) => {
  const { t } = useTranslation();
  const commissionBaselineRef = useRef(null);
  let formSchema = getEditOrderFormSchema(t);

  const onSubmit = async ({ values }) => {
    const { originalProductId: _originalProductId, ...orderValues } = values;
    const { payload, cancelled } = await applyCommissionRegenerationPrompt({
      values: orderValues,
      baseline: commissionBaselineRef.current,
    });
    if (cancelled) {
      return { success: false, cancelled: true };
    }

    formAction.close();
    await mainForm.saveValues(payload);
    await mainForm.reload();
  };

  const [renderForm, formAction, formStatus, formSetting] = useFormRender(
    formSchema,
    null,
    onSubmit
  );

  const handleActionClick = () => {
    const id = mainForm?.values._id;
    if (!id) return;
    commissionBaselineRef.current = pickCommissionAffectingSnapshot(
      mainForm.values
    );
    formAction.open({
      mode: "edit",
      id,
      data: {
        ...mainForm.values,
        originalProductId: getProductId(mainForm.values.product),
      },
    });
  };

  return (
    <>
      <Button fullWidth onClick={handleActionClick}>
        {label}
      </Button>
      {renderForm()}
    </>
  );
};

export default OrderEditButton;
